import 'css-chunksrc/client/pages/planzoneParametersPage/settings/styles.scss';export default {
  "section": "_section_fa1gh_1",
  "sectionHeader": "_sectionHeader_fa1gh_5",
  "sectionIcon": "_sectionIcon_fa1gh_14",
  "sectionTitle": "_sectionTitle_fa1gh_20",
  "row": "_row_fa1gh_26",
  "name": "_name_fa1gh_36",
  "warningRow": "_warningRow_fa1gh_43",
  "warningControls": "_warningControls_fa1gh_52"
};